import "@fortawesome/fontawesome-free/css/all.min.css";
import { Button } from "@mui/material";

interface Props {
	handleExportToExcel: () => void;
	disabled?: boolean;
}

export const ExcelButton = ({ handleExportToExcel, disabled }: Props) => {
	return (
		<Button
			size="medium"
			variant="outlined"
			disabled={disabled}
			onClick={handleExportToExcel}
			startIcon={<i className="far fa-file-excel"></i>}
			color="success"
			fullWidth
		>
			EXPORT TO EXCEL
		</Button>
	);
};
